import { LOCAL_STORAGE } from "../constants/common";

export const getToken = () =>
  localStorage.getItem(LOCAL_STORAGE.AUTH_TOKEN);

export const setToken = async (token: string) =>
  await localStorage.setItem(LOCAL_STORAGE.AUTH_TOKEN, token);
